{
  "version": 1,
  "asset_id": "0224d73d-50a8-4800-b0b9-201e5db22945",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/0224d73d-50a8-4800-b0b9-201e5db22945/avcilar-hizli-elektrikci-7-24-dukkan-5.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/0224d73d-50a8-4800-b0b9-201e5db22945/avcilar-hizli-elektrikci-7-24-dukkan-5.jpg",
  "original_filename": "avcilar-hizli-elektrikci-7-24-dukkan-5.jpg",
  "size": 570391,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T13:23:41Z"
}
